import { render } from "./App.vue?vue&type=template&id=3ce7bb45"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3ce7bb45&lang=css"
script.render = render

export default script